<lcs-loading-overlay [show]="loading$ | async | lcsCallState: 'loading'">
   <div mat-dialog-title class="dialog-header">
      <h3 class="dialog-title">{{ reportName$ | async }} Report</h3>
      <button type="button" mat-icon-button tabindex="-1" (click)="onCloseClick()"><mat-icon>close</mat-icon></button>
   </div>
   <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <mat-dialog-content>
         <ndt-report-parameters-list [formService]="formService"></ndt-report-parameters-list>
      </mat-dialog-content>
      <mat-dialog-actions>
         <button type="submit" title="Run Report" mat-raised-button>Run Report</button>
      </mat-dialog-actions>
   </form>
</lcs-loading-overlay>
